export default {
  parameters: {
    landing_id: "IDauCd",
  },
  downtimeUrl: "https://id.kodland.tech",
  ageRules: {
    min: 5,
    max: 17,
  },
  startPage: {
    image: "/welcome/quiz_indo_coding_2.jpeg",
    title: "Selesaikan survei 2 menit dan dapatkan undangan kelas pemrograman GRATIS",
    subtitle:
      "Di kelas ini, kami akan membuat proyek bersama anak anda, dan membuktikan waktu penggunaan komputer anak anda lebih bermanfaat.",
    button: "Mulai 🚀",
  },
  successPage: {
    title: "Pilih tanggal dan waktu untuk mendapatkan pelajaran GRATIS 🚀",
    subtitle: "Klik tombol “📆 Pesan” dan dapatkan pelajarannya.",
    button: "📆 Pesan",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "Terima kasih karena sudah mempercayakan kami sebagai platform edukasi Anda! Sayangnya, tablet atau handphone tidak dapat digunakan untuk mengikuti pembelajaran kami. Dengan senang hati kami akan menantikan kehadiran Anda kembali di kelas!",
  },
  quizRotateBySteps: {
    1: {
      question: "Apakah anak Anda mengikuti kegiatan ekstrakurikuler di luar pembelajaran sekolah?",
      answers: [
        "📚 Kelas yang membantu untuk meningkatkan nilai pembelajara",
        "⛹️ Ya. Kegiatan olahraga",
        "🎨 Ya. Kelas seni",
        "💻 Ya. Kelas koding dan ilmu komputer",
        "🏕️ Ya. Pramuka",
        "✖️ Tidak. Anak tidak memiliki waktu untuk itu",
      ],
    },
    2: {
      question: "Apa mata pelajaran kesukaan anak Anda?",
      answers: [
        "🔬 Sains",
        "🎨 Seni dan desain",
        "💻 Ilmu komputer",
        "🏛️ Ilmu budaya",
        "📐 Matematika",
        "💬 Ilmu Bahasa",
        "🤩 Semua yang di atas",
      ],
    },
    3: {
      question:
        "Apakah anda ingin waktu yang dihabiskan anak anda di depan komputer menjadi lebih produktif?",
      answers: ["😍 Ya!", "🙂 Tidak. Ini hanya untuk bersenang-senang dan tidak masalah."],
    },
    4: {
      question:
        "Untuk mengikuti kelas gratis ini, Anda perlu menggunakan komputer atau laptop (bukan HP) dengan koneksi internet stabil. Apakah Anda memiliki komputer/laptop di rumah?",
      answers: [
        "💻 Ya, kami memiliki komputer/laptop di rumah",
        {
          answer: "❌ Tidak, kami tidak memiliki komputer/laptop di rumah",
          stopAnswer: true,
        },
      ],
    },
  },
};
